






























































































import { Component, Vue } from 'vue-property-decorator'
import { keywordsColumns } from '../../config/colums'
import {
  getContentType,
  getAdditionalWords,
  setKeywords,
  changeStatus,
  deleteKeywords
} from '../../../../service/search'

@Component
export default class CategoryKeywords extends Vue {
  private word: string = ''
  private type: string = ''
  private keywordsColumns: any[] = keywordsColumns
  private dataSource: any[] = []
  private pagination: any = {
    current: 1,
    pageSize: 20,
    total: 0,
    showTotal: (total) => `共 ${total} 条`
  }
  private wordValue: string = ''
  private typeValue: string = ''
  private edittingId: string = ''
  private setKeywords(record?: any) {
    this.isModalVisible = true
    if (record) {
      const { id, word, first_content_type } = record

      this.wordValue = word
      this.typeValue = first_content_type
      this.edittingId = id
    }
  }
  private isModalVisible: boolean = false
  private confirmLoading: boolean = false
  private async handleModalOk(e) {
    const word = this.wordValue
    const first_content_type = this.typeValue

    if (!word || !first_content_type) {
      this.$message.info('请核对参数')
      return
    }

    let options: any = {
      word,
      first_content_type
    }

    if (this.edittingId) options.id = this.edittingId

    // 提交
    const res = await setKeywords(options)

    this.confirmLoading = true

    if (res.success) {
      this.$message.success('操作成功')
      this.word = ''
      this.type = ''
      this.renderAdditionalWords(1)
    } else {
      this.$message.error('操作失败')
    }

    this.confirmLoading = false
    this.isModalVisible = false
    this.resetModal()
  }
  private handleModalCancel(e) {
    this.isModalVisible = false
    this.resetModal()
  }
  private resetModal() {
    this.wordValue = ''
    this.typeValue = ''
    this.edittingId = ''
  }
  private mounted() {
    this.renderContentType()
    this.renderAdditionalWords(1)
  }
  private contentTypes: any[] = [] // 一级品类列表
  private async renderContentType() {
    const list = await getContentType()

    list.forEach((item) => {
      if (!['ALL', 'WORD'].includes(item.type_id)) {
        this.contentTypes.push(item)
      }
    })
  }
  private async renderAdditionalWords(page: number) {
    const { list, total } = await getAdditionalWords({
      word: this.word,
      first_content_type: this.type,
      status: '',
      page
    })

    this.pagination.total = total
    this.pagination.current = page
    this.dataSource = list
  }
  private searchAdditionalWords() {
    this.renderAdditionalWords(1)
  }
  private handleTableChange(pagination) {
    this.renderAdditionalWords(pagination.current)
  }
  private async changeStatus(status, record) {
    const { success } = await changeStatus({
      ids: [record.id],
      status
    })

    if (success) {
      this.$message.success('操作成功')
      this.renderAdditionalWords(1)
    }
  }
  private async deleteItem(record) {
    const res = await deleteKeywords({
      ids: [record.id]
    })

    if (res.success) {
      this.$message.success('删除成功')
      this.renderAdditionalWords(this.pagination.current)
    } else {
      this.$message.error('删除失败')
    }
  }
}
